<template>
  <div v-bind="$attrs" class="d-flex">
    <template v-if="smAndUp">
      <v-icon v-if="priceJustIncreased">mdi-trending-up</v-icon>
      <v-icon v-else-if="priceJustDecreased">mdi-trending-down</v-icon>
    </template>
    <FractionFormatter :fractional-price="formatFractionalPrice(aePrice)" />
    <v-progress-circular v-if="priceLoading" indeterminate size="15" />
    <span v-else-if="!hideSymbol" class="pl-1">{{ symbol }}</span>
  </div>
</template>

<script setup lang="ts">
import { defineProps, PropType } from "vue";
import { useDisplay } from "vuetify";

import { formatFractionalPrice } from "@/utils";
import { Decimal } from "@/libs/decimal";
import { AETERNITY_SYMBOL } from "@/utils/constants";

import FractionFormatter from "@/components/Common/Pricing/FractionFormatter.vue";

defineProps({
  aePrice: {
    type: Object as PropType<Decimal>,
    required: true,
  },
  symbol: {
    type: String,
    default: AETERNITY_SYMBOL,
  },
  priceLoading: Boolean,
  hideSymbol: Boolean,
  priceJustIncreased: Boolean,
  priceJustDecreased: Boolean,
});

const { smAndUp } = useDisplay();
</script>
